exports = function(val) {
    return val === null;
};

module.exports = exports;
